/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDlp = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m1.5 1.75.5-.5h9.982l.5.5v3.014a2.982 2.982 0 0 0-1-.255V2.25H2.5v10.495h4v1H2l-.5-.5V1.75Zm8.968 2.745H3.49v-1h6.978v1ZM3.49 6.512h3.948v-1H3.49v1Zm3.948 1.983H3.49v-1h3.948v1Zm3.995 4.85v-1.17a.813.813 0 0 0 .363-.875.811.811 0 0 0-.796-.626.818.818 0 0 0-.796.626.808.808 0 0 0 .363.875v1.17h.866Zm2.76-4.129.432.429v4.801l-.431.429H7.806l-.431-.429V9.645l.431-.429h.78v-1.44c0-.637.255-1.248.708-1.698a2.42 2.42 0 0 1 3.412 0c.453.45.708 1.061.708 1.698v1.44h.78ZM9.977 6.759c-.271.27-.424.636-.424 1.017v1.44h2.896v-1.44c0-.381-.152-.747-.424-1.017a1.452 1.452 0 0 0-2.048 0Zm-1.635 7.154v-3.735h5.318v3.735H8.341Z"
}));

export default SvgDlp;